import React, { useEffect, useRef } from "react";
import world from "../../assets/world.png";
import arrow from "../../assets/arrow.svg";
import { contentData } from "../../data/ContentData";
import "./Content.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const Content = () => {
  gsap.registerPlugin(ScrollTrigger);

  const ref = useRef(null);

  const timeline = gsap.timeline();

  useEffect(() => {
    const element = ref.current;

    timeline.from(element.querySelector(".left"), {
      duration: 1.5,
      opacity: 1,
      x: -80,
      ease: "none",
      scrollTrigger: {
        trigger: element.querySelector(".content"),
        start: "80px 100%",
        end: "+=200",
        scrub: true,
      },
    });
    timeline.from(element.querySelector(".right"), {
      duration: 1,
      opacity: 1,
      x: 80,
      delay: 0.4,
      stagger: {
        amount: 0.2,
      },
      ease: "none",
      scrollTrigger: {
        trigger: element.querySelector(".content"),
        start: "80px 100%",
        end: "+=200",
        scrub: true,
      },
    });
  });

  return (
    <>
      <div
        id="pricing"
        ref={ref}
        className="max-w-[1240px] mx-auto py-20 md:pt-32 px-14 sm:px-0 lg:px-4"
      >
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 content">
          <div className="items-center lg:mr-12 left">
            <img src={world} className="map-logo" alt="world" />
          </div>
          <div className="pt-12 sm:pt-0 sm:px-8 right">
            <h1>Why WalletCloud?</h1>
            <p className="w-11/12 text-justify my-6">
              WalletCloud is a blockchain wallet service provider which enable
              client apps connect to our secured service and seamlessly carryout
              transactions.
            </p>
            {contentData.map((item, index) => {
              return (
                <div
                  className="flex text-[#219653] my-6 items-center"
                  key={index}
                >
                  <p className="mr-4">{item.number}</p>
                  <p className="px-8 sm:px-12 py-6 rounded-md border-solid border border-[#2196531a] shadow-[0_20px_50px_rgba(0, 0, 0, 0.05)]">
                    {item.text}
                  </p>
                </div>
              );
            })}
            <div className="flex flex-row items-center cursor-pointer hover:-translate-y-1 ">
              <p className="mr-2">Questions? Talk to an expert</p>
              <img src={arrow} alt="arrow" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Content;
